<template>
  <div class="question-class-view">
    <div
      v-if="
        currentQuestionClass &&
        currentQuestionClass.subject_groups &&
        currentQuestionClass.subject_groups.length > 0 &&
        subjects.length > 0
      "
      class="groups-container"
    >
      <StaggeredFadeTransition class-name="ll-link-list" tag="ul" :delay="50">
        <li v-for="(s, index) in subjects" :key="s.id" :data-index="index">
          <RouterLink
            :to="'/' + currentQuestionClass.slug + '/' + s.slug"
            class="item"
          >
            <div class="progress">
              <div class="progress-bar-container">
                <div
                  class="progress-bar-fill"
                  :style="
                    'width: ' +
                    (s.question_counts.counted_answered /
                      s.question_counts.total) *
                      100 +
                    '%;'
                  "
                />
              </div>
              <div class="count">
                {{ s.question_counts.counted_answered }} /
                {{ s.question_counts.total }}
              </div>
            </div>
            <p class="name">{{ s.subject_name }}</p>
          </RouterLink>
        </li>
      </StaggeredFadeTransition>
    </div>
  </div>
</template>

<script>
import axios from "@/http";
import { mapGetters, mapActions } from "vuex";
import StaggeredFadeTransition from "@/components/StaggeredFadeTransition.vue";

export default {
  name: "QuestionClassView",
  components: { StaggeredFadeTransition },
  data() {
    return {
      groups: [],
    };
  },
  computed: {
    ...mapGetters(["tokenHeader", "currentQuestionClass", "subjects"]),
  },
  async mounted() {
    this.setPageType(this.$route.meta.pageType);
    this.setCurrentQuestionGroup(null);
    this.setCurrentQuestionSubject(null);
    this.setCurrentQuestionClass(this.$route.meta.classSlug);
    this.loadSubjects();
  },
  methods: {
    async loadSubjects() {
      this.setSubjects([]);
      let result = await axios.get(
        process.env.VUE_APP_FLL_ROOT_API +
          "/classes/" +
          this.currentQuestionClass.slug +
          "/subjects",
        {
          headers: {
            ...this.tokenHeader,
          },
        }
      );
      this.setSubjects(result.data);
    },
    ...mapActions([
      "setCurrentQuestionClass",
      "setCurrentQuestionGroup",
      "setCurrentQuestionSubject",
      "setPageType",
      "setSubjects",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.groups-container {
  padding-top: 20px;
}
</style>
